// extracted by mini-css-extract-plugin
export default {"wrapper":"s_b1","textWrapper":"s_b2"};